import { graphql } from 'gatsby';
import AboutPage from "../../../../src/pages/about";
import * as React from 'react';
export default {
  graphql,
  AboutPage,
  React
};